import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Stats from "./components/Stats";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function App() {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(() => {
    const stored = localStorage.getItem("theme");
    if (stored) return stored === "dark";
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 1024) {
        setMenuOpen(false);
      }
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (darkMode) {
      root.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      root.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <div className="font-sans text-gray-800 bg-white dark:bg-gray-900 dark:text-gray-100 min-h-screen">
      <Navbar
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        navItems={t("navItems", { returnObjects: true })}
      />
      <Hero />
      <Services
        services={t("servicesSection.items", { returnObjects: true })}
      />
      <Stats stats={t("statsSection.items", { returnObjects: true })} />
      <About />
      <Contact />
      <Footer
        navItems={t("navItems", { returnObjects: true })}
        darkMode={darkMode}
        setDarkMode={setDarkMode}
      />
    </div>
  );
}
